export default "__VITE_ASSET__ZkiSl8c$__"